<template>
  <footer class="app-footer">
    <div class="footer-container">
      <div class="info-grid">
        <div class="info-section">
          <h2>{{ $t('footer.selectYourDraw') }}</h2>
          <p>{{ $t('footer.selectYourDrawText') }}</p>
        </div>

        <div class="info-section">
          <h2>{{ $t('footer.chooseYourNumber') }}</h2>
          <p>{{ $t('footer.chooseYourNumberText') }}</p>
        </div>

        <div class="info-section">
          <h2>{{ $t('footer.submitYourBet') }}</h2>
          <p>{{ $t('footer.submitYourBetText') }}</p>
        </div>
      </div>

      <div class="features-content">
        <div class="feature-item">
          <div class="icon-wrapper">
            <img :src="footerDraws" alt="Fast" width="60" height="60" />
          </div>
          <h3>{{ $t('footer.widestSelection') }}</h3>
        </div>

        <div class="feature-item">
          <div class="icon-wrapper">
            <img :src="footerGlobalLotteries" alt="Lucky Numbers" width="60" height="60" />
          </div>
          <h3>{{ $t('footer.globalLuckyNumbers') }}</h3>
        </div>

        <div class="feature-item">
          <div class="icon-wrapper">
            <img :src="footerGreatMarkets" alt="Great Markets" width="60" height="60" />
          </div>
          <h3>{{ $t('footer.greatMarkets') }}</h3>
        </div>

        <div class="feature-item">
          <div class="icon-wrapper">
            <img :src="footerFastResults" alt="Fast Results" width="60" height="60" />
          </div>
          <h3>{{ $t('footer.fastResults') }}</h3>
        </div>
      </div>
    </div>

    <div class="footer-bottom">
      <div class="footer-bottom-container">
        <router-link :to="{ path: '/terms-and-conditions', query: route.query }" class="footer-bottom-link">{{ $t('nav.termsAndConditions') }}</router-link> | <router-link :to="{ path: '/wagers', query: route.query }" class="footer-bottom-link">{{ $t('nav.wagers') }}</router-link> | <span class="footer-bottom-version">{{ $t('common.version') }}: 1.0.1</span>
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { defineOptions } from 'vue'
import { useRoute } from 'vue-router'
import { useTheme } from '@/composables/useTheme'

defineOptions({
  name: 'AppFooter'
})

const route = useRoute()
const { getAssetPath } = useTheme()

const footerDraws = computed(() => getAssetPath('footer', 'draws') || '/img/images/footer/01-draws.png')
const footerGlobalLotteries = computed(() => getAssetPath('footer', 'globalLotteries') || '/img/images/footer/02-global-lotteries.png')
const footerGreatMarkets = computed(() => getAssetPath('footer', 'greatMarkets') || '/img/images/footer/03-great-markets.png')
const footerFastResults = computed(() => getAssetPath('footer', 'fastResults') || '/img/images/footer/04-fast-results.png')
</script>
<style scoped>
.app-footer {
  width: 100vw;
  margin-left: calc(-50vw + 50%);
  margin-right: calc(-50vw + 50%);
}

.footer-container {
  max-width: 1280px;
  margin: 0 auto;
}

.info-grid {
  background: var(--footer-bg) !important;
  width: 100%;
  margin: 30px 0;
  padding: 32px 0;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 32px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.info-section {
  display: flex;
  flex-direction: column;
  padding: 0 16px;
  gap: 16px;
}

.info-section h2 {
  color: var(--accent-color-text-heading);
  font-size: 20px;
  font-weight: 600;
  margin: 0;
}

.info-section p {
  color: var(--text-light);
  font-size: 16px;
  line-height: 1.6;
  margin: 0;
}

.features-content {
  width: 100%;
  margin: 0;
  padding: 32px 0;
  display: flex;
  justify-content: space-around;
  align-items: center;
  gap: 24px;
  background: var(--footer-bg2, var(--footer-bg, var(--bg-dark))) !important;
}

.feature-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  text-align: center;
}

.icon-wrapper {
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text-white);
}
.icon-wrapper img {
  filter: var(--footer-icon-filter, none);
}
.feature-item h3 {
  color: var(--text-white);
  font-size: 18px;
  font-weight: 500;
  margin: 0;
  white-space: nowrap;
}

.footer-bottom {
  width: 100%;
  padding: 16px 0;
  text-align: center;
}

.footer-bottom-link {
  color: var(--text-primary);
  font-size: 14px;
  font-weight: 500;
  text-decoration: none;
}

.footer-bottom-version {
  color: var(--text-primary);
  font-size: 14px;
  font-weight: 500;
}


@media (max-width: 1024px) {
  .info-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .footer-container {
    padding: 0 0px;
  }

  .features-content {
    display: none;
  }

  .info-grid {
    text-align: left;
  }

  .info-section h2 {
    font-size: 20px;
  }

  .info-section p {
    font-size: 14px;
  }
}

</style> 